import { prefixObjectValues } from '../../../utils';
const form = {
  form: 'form',
  typeSelect: 'type-select',
  primaryCheck: 'primary-check',
  NumInput: 'phone-num',
  submitBtn: 'submit-btn',
  countryCodeSelect: 'county-code-select',
};

export default prefixObjectValues(form, 'profile-phone-form');
